import script from "./UserManagementPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManagementPage.vue?vue&type=script&setup=true&lang=js"

import "./UserManagementPage.vue?vue&type=style&index=0&id=319c3fdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319c3fdd"]])

export default __exports__